<template>
  <div class="scroll-container" :style="{ height: h + 'px', width: w + 'px' }">
    <seamless-scroll :data="list" :class-option="option">
      <ul class="item-wrapper">
        <li v-for="(item, index) in list" :key="index" class="scroll-item">
            <div class="item-content">
                <div style="display: flex;width: 100%; justify-content: space-between;align-items: center;">
                    <div style="position: relative;">
                        <div style="position: absolute; top: 50%; left: 45px;right: 0;bottom: 0;transform: translateY(-50%);">
                            <div style="font-size: 12px;">{{ item.todoDateTime.slice(0, -3) }}</div>
                        </div>
                        <img :src="$staticUrl('/statics/2025/09/15/bg2_20250915151602A086.png')" alt="" style="width: 160px;height: 35px;">
                    </div>
                    <div style="border: 1px solid #76E1D7;background: rgba(118,225,215,0.2);border-radius: 5px;font-size: 12px;color: #75DFD4;display: flex;align-items: center;padding: 5px 15px;" @click="navTodo(item)">
                        详情
                    </div>
                </div>
                <div style="font-size: 14px;color: #fff; text-align: center;margin-top: 10px;" :style="{ width: w + 'px' }">{{ item.estateName }}已有{{ item.todoNum }}项待办事件超时，请及时处理！</div>
            </div>
        </li>
      </ul>
    </seamless-scroll>
  </div>
</template>

<script>
export default {
  name: 'Vuecomm03xy',
  props: {
    list: {
      type: Array,
      required: true,
      default: () => ([])
    },
    w: {
      type: [Number, String],
      default: 400
    },
    h: {
      type: [Number, String],
      default: 200
    },
    speed: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      option: {
        direction: 1, // 0 往下 1 往上 2往左 3往右
        step: 1, // 步长
        limitMoveNum: this.list.length, // 开始滚动的数据量，设置为1表示有数据就开始滚动
        hoverStop: true, // 是否开启鼠标悬停
        openWatch: false, // 开启数据实时监控
        singleHeight: 100, // 单行高度，需要与CSS中的高度一致
        singleWidth: 0, // 单行宽度
        waitTime: 1000, // 单步停止时间
        switchSingleStep: 100, // 单步移动距离，与singleHeight一致
        autoPlay: true, // 自动播放
        switchDelay: 5000 // 动画时间
      }
    }
  },
  methods: {
    navTodo(item) {
      window.open(`/to_do?projectId=${item.estateId}`, '_self')
    }
  }
}
</script>

<style scoped>
.scroll-container {
  overflow: hidden;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
}

.item-wrapper {
  margin: 0;
  padding: 0;
  list-style: none;
}

.scroll-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  height: 100px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

.status-dot-error {
  background-color: #ff4d4f;
  box-shadow: 0 0 6px #ff4d4f;
}

.status-dot-normal {
  background-color: #52c41a;
  box-shadow: 0 0 6px #52c41a;
}

.item-content {
  font-size: 14px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>